/**
 * Route for `day-parting-schedule-targeting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DayPartingScheduleTargetingPage } from "../features/day-parting-schedule-targeting/DayPartingScheduleTargetingPage";

export const dayPartingScheduleTargetingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/day-parting-schedule-targeting",
	component: DayPartingScheduleTargetingPage,
});

export default dayPartingScheduleTargetingRoute;
